<div class="container" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
    <button mat-icon-button [ngClass]="{'closeLTR': locale.lang === 'en', 'closeRTL': locale.lang !== 'en'}" (click)="onClose()">
		<mat-icon>close</mat-icon>
	</button>

    <div mat-dialog-content style="width: 90%;">
        <p>
            {{ data['message'] }}
        </p>
    </div>

    <div mat-dialog-actions>
        <button mat-button [color]="data['colors'] && data['colors']['yes'] ? data['colors']['yes'] : 'warn'" (click)="onYes()" cdkFocusInitial>{{ data['yes'] }}</button>
        <button mat-button [color]="data['colors'] && data['colors']['no'] ? data['colors']['no'] : null" (click)="onNo()">{{ data['no'] }}</button>
    </div>
</div>
